module.exports = __webpack_public_path__ + "LatoLatin-LightItalic.80343ed6ac637183d30c.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-LightItalic.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-LightItalic.woff2
// module chunks = styles